// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"877aa0e8","832":"f5d843d5"}[chunkId] + ".chunk.js";
};